import { useCallback } from 'react'

import {
  getSessionLimitProgramCategoryByTreatmentOption,
  ProgramCategory,
  TREATMENT_OPTIONS,
  TREATMENT_OPTIONS_TYPE,
} from '@lyrahealth-inc/shared-app-logic'

export type GetIsEAPSessionCountExhaustedOptions = {
  // treatment option can be expectedly undefined if treatment option has not been selected yet during triage
  treatmentOption?: TREATMENT_OPTIONS_TYPE | undefined | null
}

export function useGetIsEAPSessionCountExhaustedShared(
  isTotalEAPSessionCountExhausted: boolean,
  isTotalEAPSessionCountExhaustedWithoutOverrides: boolean,
  getIsEAPSessionCountExhaustedByProgram: (programCategory: ProgramCategory | undefined) => boolean,
  forceAdultFlowsToHPIForAmazonExceptCFP: boolean = false,
) {
  return useCallback(
    (options?: GetIsEAPSessionCountExhaustedOptions) => {
      const { treatmentOption } = options ?? {}

      // For Amazon:
      // - For CoachingForParents: Check the actual session limit.
      // - For any other treatment option, fall through and use the passed-in value for isTotalEAPSessionCountExhausted,
      // which factors in minor vs adult searcher status.
      if (forceAdultFlowsToHPIForAmazonExceptCFP && treatmentOption === TREATMENT_OPTIONS.COACHING_FOR_PARENTS) {
        return isTotalEAPSessionCountExhaustedWithoutOverrides
      }

      if (treatmentOption == null) {
        // if treatment option is unknown or program-level session limit is disabled,
        // return whether overall session limit is exhausted
        return isTotalEAPSessionCountExhausted
      } else {
        const programCategory = getSessionLimitProgramCategoryByTreatmentOption(treatmentOption)
        const isEAPSessionCountExhaustedByProgram = getIsEAPSessionCountExhaustedByProgram(programCategory)
        return isEAPSessionCountExhaustedByProgram
      }
    },
    [
      forceAdultFlowsToHPIForAmazonExceptCFP,
      isTotalEAPSessionCountExhausted,
      isTotalEAPSessionCountExhaustedWithoutOverrides,
      getIsEAPSessionCountExhaustedByProgram,
    ],
  )
}
